<script lang="ts">
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import TrackingContext from "@shared/svelte/Components/Tracking/TrackingContext.svelte";
  import { getCloudinaryUrl } from "@shared/services/cloudinary_image_url_service";
  import { reformatUrlAndGetTargetValue } from "@shared/services/target_value_forward_urls";
  import type { RecipeCard } from "@shared/types/RecipeCard";
  import { EventTracking } from "@shared/services/event_tracking/events";
  import {
    CustomContentRecipeSectionEntity,
    RecipeCardEntity,
  } from "@shared/services/event_tracking/entities";
  import { cloudinaryParams } from "@shared/services/discovery_image_dimensions";

  const { trackClick, trackMrcEvents } = EventTracking;

  export let recipeCards: RecipeCard[];
  export let displaySponsoredLabel: boolean = false;
  export let trackingData: { id: number; position: number };

  // Unused props passed from discovery panel
  export let mobileMode = undefined;
  mobileMode;

  const trackingParams: CustomContentRecipeSectionEntity[] = [
    new CustomContentRecipeSectionEntity(trackingData),
  ];

  const formatOptionalIngredientFields = (amount, unit) => {
    amount = amount ? amount : "";
    unit = unit ? unit : "";
    return `${amount} ${unit}`;
  };

  const addRecipeCardEntity = (trackingContext, recipe) => {
    return [
      trackingContext.entities.concat(
        new RecipeCardEntity({ id: recipe.id, position: recipe.position }),
      ),
    ];
  };

  const getRecipeCardHref = (forwardUrl: string) => {
    const { href } = reformatUrlAndGetTargetValue(forwardUrl);
    return href;
  };

  const getRecipeCardTarget = (forwardUrl: string) => {
    const { target } = reformatUrlAndGetTargetValue(forwardUrl);
    return target;
  };

  const recipeHeader = displaySponsoredLabel ? "Sponsored Recipe" : "Recipe";
</script>

<TrackingContext entities={trackingParams} let:trackingContext>
  <div class="fizz-flex-row-responsive fizz-align-stretch fizz-inset-square-16 fizz-container">
    {#each recipeCards as recipe}
      <div
        class="fizz-card fizz-bordered fizz-flex-item fizz-text-medium"
        style="display: grid; grid-template-rows: auto 1fr auto"
        use:trackMrcEvents={addRecipeCardEntity(trackingContext, recipe)}
      >
        <div class="fizz-image-overlay fizz-stack-16" style="--aspect-ratio: 650/280">
          <img
            src={getCloudinaryUrl(recipe.image_upload_url, cloudinaryParams.recipeCard)}
            alt={recipe.image_alt_text}
          />
          <div class="fizz-inset-square-16">
            <p class="fizz-text-small" data-testid="recipe-card-header">{recipeHeader}</p>
            <p class="fizz-heading-3">{recipe.recipe_name}</p>
          </div>
        </div>

        <div class="fizz-inset-horizontal-16">
          <div class="fizz-flex-row fizz-stack-16">
            <div class="fizz-flex-row-4 fizz-text-strong fizz-text-brand fizz-flex-item">
              <Icon type="LittleBottle" extraClassNames="fizz-icon-16" />
              <span>Ingredients</span>
            </div>
            <div
              class="fizz-flex-row-4 fizz-text-medium fizz-text-strong fizz-text-brand fizz-flex-item"
            >
              <Icon type="MartiniGlass" extraClassNames="fizz-icon-12" fill={"#002b48"} />
              <span>How to Make</span>
            </div>
          </div>
          <div class="fizz-padded-border-top fizz-flex-row fizz-align-content-start">
            <div class="fizz-flex-item">
              <dl class="fizz-definition-list-horizontal">
                {#each recipe.recipe_card_ingredients_attributes as i}
                  <dt>
                    {formatOptionalIngredientFields(i.amount, i.unit_of_measure)}
                  </dt>
                  <dd>{i.ingredient}</dd>
                {/each}
              </dl>
            </div>
            <div class="fizz-flex-item">
              <p>
                {recipe.how_to_make}
              </p>
            </div>
          </div>
        </div>

        <div class="fizz-text-strong fizz-inset-square-16">
          <a
            on:click={e =>
              trackClick(
                null,
                trackingContext.entities.concat(
                  new RecipeCardEntity({ id: recipe.id, position: recipe.position }),
                ),
              )}
            href={getRecipeCardHref(recipe.forward_url)}
            target={getRecipeCardTarget(recipe.forward_url)}>{recipe.forward_text}</a
          >
        </div>
      </div>
    {/each}
  </div>
</TrackingContext>
